export const en = {
  // Common
  common: {
    language: 'en'
  },

  // Navigation
  nav: {
    home: 'Home',
    product: 'Product',
    demo: 'Demo',
    solutions: 'Solutions',
    cases: 'Cases',
    pricing: 'Pricing',
    resources: 'Resources',
    login: 'Login',
    freeTrial: 'Free Trial'
  },

  // Hero Section
  hero: {
    badge: 'DecisionAI 2.0 New Upgrade',
    brand: 'DecisionAI',
    title: {
      line1: 'Make Data Speak',
      line2: 'Smarter Decisions'
    },
    subtitle: 'Agent + Tool Smart Scheduling Architecture, Turn Oracle Database into AI Assistant in 3 Minutes',
    features: {
      scheduling: 'Smart Scheduling',
      oracle: 'Oracle Native',
      config: 'Simple Config'
    },
    description: {
      line1: 'Oracle Native Support',
      line2: 'Multi-modal Data Fusion',
      line3: 'Private Knowledge to Cloud'
    },
    cta: {
      primary: 'Get Started - Free Trial',
      secondary: 'Learn More'
    },
    highlights: {
      oracle: {
        title: 'Oracle',
        subtitle: 'Native Deep Integration'
      },
      agent: {
        title: 'Agent+Tool',
        subtitle: 'Smart Scheduling Architecture'
      },
      code: {
        title: '0-Code',
        subtitle: 'Simple Configuration Launch'
      }
    },
    rightPanel: {
      analysis: 'Real-time Data Analysis',
      insight: 'AI Smart Insights',
      decision: 'Decision Recommendations'
    },
    scrollHint: 'Scroll down to explore more'
  },

  // Demo Section
  demo: {
    title: 'Experience DAI 2.0 Agent + Tool Smart Scheduling',
    subtitle: 'Watch how Agent intelligently decomposes complex tasks, dynamically schedules multiple Tools to work together, achieving multi-modal data fusion analysis.',

    // Guide related
    guide: {
      title: 'Start Your AI Demo Journey',
      subtitle: 'Choose an industry scenario and experience the power of AI intelligent analysis',
      step1: 'Select Industry',
      step1Desc: 'Choose from e-commerce, manufacturing, or finance industries',
      step2: 'Select Question',
      step2Desc: 'Choose a specific business question for analysis',
      step3: 'Start Demo',
      step3Desc: 'Click the start button to watch the AI intelligent analysis process',
      skip: 'Skip Guide',
      startHere: 'Start Here! Select an Industry',
      selectQuestionHint: 'Now Select a Question to Analyze',
      clickToStart: 'Click Send to Start AI Demo!'
    },
    showcase: {
      title: 'Agent + Tool Smart Scheduling Demo',
      subtitle: 'Select domain and questions to experience intelligent analysis process',
      selectDomain: 'Select Analysis Domain',
      selectQuestion: 'Select Question',
      back: 'Back',
      currentQuestion: 'Current Question'
    },
    industries: {
      ecommerce: {
        title: 'E-commerce',
        subtitle: 'Retail e-commerce data analysis'
      },
      manufacturing: {
        title: 'Manufacturing',
        subtitle: 'Manufacturing production data analysis'
      },
      finance: {
        title: 'Financial Services',
        subtitle: 'Financial business data analysis'
      }
    },
    questions: {
      retail: {
        sales: 'Sales Data Analysis',
        salesQuestion: 'What are the reasons for the sales decline in the past month?',
        salesTags: ['Sales', 'Trend Analysis'],
        product: 'Product Performance Analysis',
        productQuestion: 'Which products sold well in the past year?',
        productTags: ['Product', 'Sales Ranking'],
        customer: 'Customer Behavior Insights',
        customerQuestion: 'Analyze customer purchasing behavior and identify high-value customer groups',
        customerTags: ['Customer', 'Behavior Analysis']
      },
      manufacturing: {
        efficiency: 'Production Efficiency Analysis',
        efficiencyQuestion: 'Help me analyze the daily production targets of each base in March',
        efficiencyTags: ['Production', 'Efficiency'],
        operation: 'Factory Operations Analysis',
        operationQuestion: 'How are the daily trends of each factory in Yixing?',
        operationTags: ['Factory', 'Trends'],
        quality: 'Quality Control Analysis',
        qualityQuestion: 'How many fragments were there in the three bases last month?',
        qualityTags: ['Quality', 'Control']
      },
      finance: {
        risk: 'Risk Assessment Analysis',
        riskQuestion: 'Please help me assess whether ABC company has loan risks',
        riskTags: ['Risk', 'Assessment'],
        portfolio: 'Investment Portfolio Optimization',
        portfolioQuestion: 'Based on historical return data, optimize investment portfolio allocation recommendations',
        portfolioTags: ['Investment', 'Optimization'],
        fraud: 'Transaction Anomaly Detection',
        fraudQuestion: 'Identify abnormal transaction patterns to enhance anti-fraud capabilities',
        fraudTags: ['Anomaly', 'Detection']
      }
    },
    assistant: {
      title: 'DecisionAI Assistant',
      subtitle: 'Intelligent Data Analysis Expert',
      status: 'Online',
      placeholder: 'Please select an analysis question on the left first',
      inputPlaceholder: 'Click send to start analysis...',
      demoNote: 'This is a demo environment. The actual product supports connecting to your real data sources'
    },
    toolScheduling: {
      agentScheduling: '🔄 Agent Smart Scheduling...',
      tools: {
        sqlTool: 'SQL Tool',
        graphTool: 'Graph Tool',
        vectorTool: 'Vector Tool'
      }
    },
    cta: {
      title: 'Ready to Experience Agent + Tool Smart Data Platform?',
      subtitle: 'Make your Oracle database "speak" in minutes, experience the powerful capabilities of multi-modal data fusion analysis',
      primary: 'Start Free Trial',
      secondary: 'Book Product Demo'
    },
    analysis: {
      reselect: 'Reselect',
      restartDemo: 'Restart Demo',
      demoInProgress: 'Demo in progress...',
      phases: {
        intentConfirmation: 'Problem Identification + Intent Confirmation',
        basicInfoQuery: 'Basic Information Query',
        riskAnalysis: 'Risk Comprehensive Analysis',
        riskReport: 'Risk Assessment Report',
        dataAnalysis: 'Data Analysis',
        reportGeneration: 'Report Generation',
        portfolioAnalysis: 'Portfolio Analysis',
        anomalyDetection: 'Anomaly Detection',
        productionAnalysis: 'Production Analysis',
        qualityAnalysis: 'Quality Analysis',
        trendAnalysis: 'Trend Analysis'
      },
      descriptions: {
        intentConfirmation: 'AI confirms user intent and formulates analysis plan',
        basicInfoQuery: 'Obtain basic company registration information and credit status',
        riskAnalysis: 'Multi-dimensional analysis of company risk status',
        riskReport: 'Generate complete risk assessment report and risk control recommendations',
        dataAnalysis: 'Analyze data patterns and trends',
        reportGeneration: 'Generate comprehensive analysis report',
        portfolioAnalysis: 'Analyze investment portfolio performance',
        anomalyDetection: 'Detect abnormal patterns in data',
        productionAnalysis: 'Analyze production efficiency and targets',
        qualityAnalysis: 'Analyze quality control metrics',
        trendAnalysis: 'Analyze trends and patterns over time',

        // 投资组合相关
        portfolioHistoricalAnalysis: 'Analyze historical return performance of various asset classes',
        portfolioOptimization: 'Calculate optimal investment portfolio allocation plans',
        portfolioReport: 'Generate complete investment portfolio optimization report',

        // 电商零售相关
        salesTrendQuery: 'SQL Tool executes data query to confirm sales decline trend',
        multiToolAnalysis: 'Agent schedules multi-Tool parallel analysis for comprehensive problem diagnosis',
        analysisReport: 'Generate complete analysis report and decision recommendations',
        productProfitQuery: 'SQL Tool executes data query to get product profit rankings',
        productFeatureAnalysis: 'Agent schedules multi-Tool analysis for deep product feature mining',
        productInsightReport: 'Generate product insight report and marketing recommendations',
        productCategoryAnalysis: 'Deep analysis of product categories and brand characteristics',
        productStrategyReport: 'Generate complete product analysis report and strategic recommendations',
        customerBehaviorQuery: 'SQL Tool executes data query to analyze customer behavior',
        customerFeatureAnalysis: 'Agent schedules multi-Tool deep analysis of customer characteristics',
        customerValueReport: 'Generate customer value analysis and operational recommendations',

        // 客户行为洞察相关
        customerSpendingAnalysis: 'Analyze customer spending distribution and value segmentation',
        customerGroupAnalysis: 'In-depth analysis of behavioral characteristics of different value customer groups',
        customerInsightReport: 'Generate complete customer value insight report and marketing strategies',

        // 金融风控相关
        transactionDataPreprocessing: 'Obtain transaction data and perform preprocessing analysis',
        fraudDetectionAlgorithms: 'Apply multiple algorithms to identify abnormal transaction patterns',
        fraudMonitoringReport: 'Generate complete anti-fraud monitoring report and processing recommendations',
        mlFraudDetection: 'Apply machine learning algorithms to identify abnormal transactions',
        fraudControlPlan: 'Generate anti-fraud monitoring recommendations and risk control plans',

        // 生产制造相关
        productionSchedulingQuery: 'SQL Tool executes data query to get production scheduling data',
        productionTrendAnalysis: 'Agent schedules multi-Tool analysis of production scheduling trends',
        productionOptimizationReport: 'Generate production scheduling optimization recommendations and improvement plans',
        factoryPerformanceQuery: 'SQL Tool executes data query to get factory performance data',
        factoryEfficiencyAnalysis: 'Agent schedules multi-Tool analysis of factory efficiency',
        factoryOptimizationReport: 'Generate factory optimization recommendations and management plans',
        qualityDataQuery: 'SQL Tool executes data query to get quality data',
        qualityIssueDiagnosis: 'Agent schedules multi-Tool diagnosis of quality issues',
        qualityImprovementReport: 'Generate quality improvement recommendations and control plans',

        // 生产制造具体描述
        dailyProductionTargetQuery: 'Query daily production scheduling target data for each base in March',
        productionTrendDetailAnalysis: 'In-depth analysis of production scheduling trends and characteristics of each base',
        productionAnalysisReport: 'Generate complete production scheduling analysis report and optimization recommendations',
        factoryKeyIndicatorQuery: 'Query daily key indicators for each factory at Yixing base',
        factoryPerformanceDetailAnalysis: 'In-depth analysis of performance differences and trends among factories',
        factoryAnalysisReport: 'Generate complete factory analysis report and optimization recommendations',
        fragmentationRateQuery: 'Query and analyze fragmentation rate data for each base',
        qualityControlAnalysis: 'In-depth analysis of quality control differences among bases',
        qualityAnalysisReport: 'Generate complete quality analysis report and improvement recommendations'
      },

      // Demo conversation content
      content: {
        // Intent confirmation
        intentConfirmation: {
          title: '✓ **Intent Confirmation Complete**',
          analysisIntent: '🎯 **Analysis Intent**',
          executionPlan: '📋 **Execution Plan**'
        },

        // Tool execution
        toolExecution: {
          sqlQuery: '🔍 **Executing Tool: Auto SQL Query**',
          duration: '⏱️ **Duration: {duration} ms**',
          queryResults: '📊 **Query Results**',
          chartAnalysis: '📈 **Smart Chart Analysis**',
          chartGenerated: 'Chart generated'
        },

        // Agent scheduling
        agentScheduling: {
          multiTool: '🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**',
          keyFindings: '🎯 **Key Findings**',
          comparison: '📈 **Comparison Analysis**'
        },

        // Common phrases
        common: {
          decrease: 'decrease',
          increase: 'increase',
          stable: 'stable',
          normal: 'normal',
          abnormal: 'abnormal',
          high: 'high',
          medium: 'medium',
          low: 'low',
          risk: 'risk',
          warning: '⚠️',
          success: '✅',
          yuan: 'yuan',
          percent: '%',
          // Analysis phases
          intentConfirmationPhase: 'Problem Identification + Intent Confirmation',
          basicInfoQueryPhase: 'Basic Information Query',
          riskAnalysisPhase: 'Risk Comprehensive Analysis',
          riskReportPhase: 'Risk Assessment Report',
          trendAnalysisPhase: 'Overall Trend Analysis',
          deepAnalysisPhase: 'Multi-dimensional Deep Analysis',
          comprehensiveReportPhase: 'Comprehensive Analysis Report',
          productAnalysisPhase: 'Product Profit Analysis',
          featureAnalysisPhase: 'Product Feature Analysis',
          marketInsightPhase: 'Market Insight Report',
          customerAnalysisPhase: 'Customer Consumption Analysis',
          behaviorAnalysisPhase: 'Customer Behavior Deep Analysis',
          customerInsightPhase: 'Customer Value Insight Report',
          productionQueryPhase: 'Production Data Query',
          productionTrendPhase: 'Production Trend Analysis',
          optimizationReportPhase: 'Optimization Recommendation Report',
          factoryQueryPhase: 'Factory Data Query',
          factoryAnalysisPhase: 'Factory Performance Analysis',
          factoryOptimizationPhase: 'Factory Optimization Recommendations',
          dataQueryAnalysisPhase: 'Data Query Analysis',
          qualityAnalysisPhase: 'Quality Analysis Diagnosis',
          improvementReportPhase: 'Improvement Recommendation Report',
          historicalAnalysisPhase: 'Historical Return Analysis',
          riskOptimizationPhase: 'Risk-Return Optimization',
          investmentReportPhase: 'Investment Recommendation Report',
          transactionAnalysisPhase: 'Transaction Data Analysis',
          anomalyDetectionPhase: 'Anomaly Pattern Recognition',
          antifraudReportPhase: 'Anti-fraud Monitoring Report'
        }
      }
    }
  },

  // Product Value
  productValue: {
    badge: 'DecisionAI 2.0 Core Value',
    title: 'AI Agent Redefines Data Analysis',
    subtitle: 'Upgrade from traditional data query tools to intelligent decision assistants',
    values: {
      naturalLanguage: {
        title: 'Natural Language Interaction',
        description: 'Ask data like chatting, zero code barrier',
        benefit: 'Reduce usage barrier by 90%'
      },
      aiInsight: {
        title: 'AI Smart Insights',
        description: 'Automatically discover data patterns, generate business insights',
        benefit: 'Improve analysis efficiency by 10x'
      },
      smartScheduling: {
        title: 'Smart Scheduling Architecture',
        description: 'Agent + Tool collaborative work',
        benefit: 'Multi-modal data fusion analysis'
      },
      precisionDecision: {
        title: 'Precision Decision Recommendations',
        description: 'Generate actionable decision recommendations based on data',
        benefit: 'Improve decision accuracy by 80%'
      }
    },
    industryScenarios: {
      title: 'Industry Application Scenarios',
      subtitle: 'Provide professional AI data analysis solutions tailored to different industry characteristics',
      selectorTitle: 'Select Your Industry',
      selectorSubtitle: 'Explore AI solutions tailored for your industry'
    },
    whyChooseUs: {
      title: 'Why Choose DecisionAI?',
      point1: 'Deep industry experience, we understand your business',
      point2: 'Oracle native support, secure and reliable data',
      point3: '3-minute rapid deployment, immediate results'
    },
    viewAllIndustries: 'View All Industry Solutions',
    caseStudy: {
      title: 'Customer Case Study'
    },
    demoQuestions: {
      title: 'Common Analysis Questions'
    },
    industryStats: {
      title: 'Industry Leading Data'
    }
  },

  // Industry Application Scenarios Details
  industries: {
    ecommerce: {
      title: 'E-commerce Retail',
      subtitle: 'AI-Driven Smart Business Decisions',
      description: 'Conversational data analysis, making every operator a data expert',
      briefDesc: 'Focused on e-commerce business scenarios, covering users, products, and marketing',
      keyMetric: '🎆 Customer operation efficiency +60%',
      features: {
        userProfile: {
          title: 'Smart User Profiling',
          description: 'AI automatically analyzes user behavior to accurately identify high-value customers',
          metric: '15% increase in member customer value'
        },
        productPrediction: {
          title: 'Hot Product Prediction Analysis',
          description: 'Based on historical data and market trends, AI predicts potential hot products',
          metric: '85% accuracy in hot product identification'
        },
        adOptimization: {
          title: 'Smart Ad Optimization',
          description: 'AI optimizes advertising strategies in real-time to reduce customer acquisition costs',
          metric: '25% improvement in ad ROI'
        }
      },
      caseStudy: {
        company: 'A Leading E-commerce Platform',
        result: 'After using DecisionAI, operational efficiency improved by 60%, decision time reduced from days to minutes'
      },
      demoQuestions: [
        'Which product category has the fastest sales growth this month?',
        'What are the purchasing behavior characteristics of high-value users?',
        'How to optimize advertising to improve conversion rates?'
      ]
    },
    manufacturing: {
      title: 'Manufacturing',
      subtitle: 'AI-Empowered Smart Manufacturing Decisions',
      description: 'From production data to business insights, AI assists manufacturing digital transformation',
      briefDesc: '20 years of manufacturing expertise, understanding production, quality, and operations',
      keyMetric: '🏆 Production efficiency +35%',
      features: {
        qualityMonitoring: {
          title: 'Smart Quality Monitoring',
          description: 'AI analyzes production data in real-time to predict quality risks',
          metric: '92% accuracy in quality issue prediction'
        },
        supplyChain: {
          title: 'Supply Chain Optimization',
          description: 'AI optimizes inventory management to reduce capital occupation',
          metric: '30% improvement in inventory turnover'
        },
        predictiveMaintenance: {
          title: 'Predictive Equipment Maintenance',
          description: 'Based on equipment data, AI predicts maintenance needs',
          metric: '40% reduction in equipment failure rate'
        }
      },
      caseStudy: {
        company: 'A Large Manufacturing Enterprise',
        result: 'Through AI data analysis, production efficiency improved by 35%, operating costs reduced by 20%'
      },
      demoQuestions: [
        'Which production line has the highest efficiency?',
        'Does raw material inventory need replenishment?',
        'How should equipment maintenance be scheduled?'
      ]
    },
    franchise: {
      title: 'Chain Franchise',
      subtitle: 'AI-Driven Chain Operations Management',
      description: 'Unified data standards, AI insights help chain brands scale development',
      briefDesc: 'One-stop chain management platform, making every store the best store',
      keyMetric: '📈 Store productivity +45%',
      features: {
        storeAnalysis: {
          title: 'Store Operations Analysis',
          description: 'AI analyzes store operational data to identify best practices',
          metric: '45% improvement in store efficiency per person'
        },
        locationRecommendation: {
          title: 'Smart Location Recommendation',
          description: 'Based on foot traffic, competition and other data, AI recommends optimal locations',
          metric: '60% improvement in new store success rate'
        },
        franchiseeSupport: {
          title: 'Franchisee Support',
          description: 'AI generates personalized business recommendations to improve franchisee profitability',
          metric: '95% franchisee satisfaction'
        }
      },
      caseStudy: {
        company: 'A Well-known Chain Brand',
        result: 'AI data analysis helps optimize store operations, overall profitability improved by 28%'
      },
      demoQuestions: [
        'Which store\'s business model is most worth promoting?',
        'Where should new stores be located?',
        'How to improve franchisee operational efficiency?'
      ]
    },
    finance: {
      title: 'Financial Services',
      subtitle: 'AI-Driven Smart Risk Control Decisions',
      description: 'Real-time risk assessment, AI assists financial institutions in precise decision-making',
      briefDesc: 'Multi-modal data fusion analysis, comprehensive financial risk identification',
      keyMetric: '🔒 Risk identification accuracy 96%',
      features: {
        riskControl: {
          title: 'Smart Risk Control Model',
          description: 'AI evaluates customer credit risk in real-time to reduce bad debt rates',
          metric: '96% accuracy in risk identification'
        },
        customerValue: {
          title: 'Customer Value Analysis',
          description: 'AI analyzes customer behavior to identify high-value customers',
          metric: '40% improvement in customer value'
        },
        productRecommendation: {
          title: 'Product Recommendation Engine',
          description: 'Based on customer profiles, AI recommends suitable financial products',
          metric: '55% improvement in product conversion rate'
        }
      },
      caseStudy: {
        company: 'A City Commercial Bank',
        result: 'After AI risk control system launch, risk losses reduced by 50%, business efficiency improved 3x'
      },
      demoQuestions: [
        'What is this customer\'s credit risk?',
        'Which products are most suitable to recommend to this type of customer?',
        'How to optimize risk control strategies?'
      ]
    }
  },

  // Industry Statistics
  industryStats: {
    clients: {
      number: '500+',
      label: 'Enterprise Clients',
      description: 'Across all industries'
    },
    accuracy: {
      number: '99.9%',
      label: 'Accuracy',
      description: 'AI analysis accuracy'
    },
    efficiency: {
      number: '10x',
      label: 'Efficiency Improvement',
      description: 'Compared to traditional methods'
    },
    response: {
      number: 'Instant',
      label: 'Response Speed',
      description: 'Real-time data analysis'
    }
  },

  // Feature Showcase
  featureShowcase: {
    naturalLanguage: {
      mainTitle: 'Natural Language Querying',
      subTitle: 'AI-powered self-service analysis - A data analysis assistant that everyone can use with zero barriers',
      details: [
        'Direct natural language data queries',
        'Smart follow-up multi-turn conversations',
        'Automatic generation of various charts'
      ]
    },
    smartAgent: {
      mainTitle: 'Smart Metrics Agent',
      subTitle: 'Every metric delivers instant, professional insights',
      details: [
        'Zero-code enterprise-level metric modeling',
        'Layer-by-layer drill-down, multi-dimensional analysis',
        'AI data insights, one-click professional reports'
      ]
    },
    zeroHallucination: {
      mainTitle: 'Zero-Hallucination Data Analysis LLM',
      subTitle: 'Every Q&A is stable and trustworthy',
      details: [
        'RAG + Enterprise knowledge base',
        'Proprietary element extraction and keyword highlighting',
        '100% accuracy in every data Q&A'
      ]
    }
  },

  // Core capabilities section
  coreCapabilities: {
    title: 'DAI 2.0 Core Features',
    mainTitle: 'Agent + Tool Architecture, Making Data Intelligence Real',
    description: 'Deep integration with Oracle advanced features, based on Agent intelligent scheduling of multiple Tools, achieving full-process automation from natural language queries to insight reports.',

    oracleAdvanced: {
      title: 'Oracle Advanced Features Native Support',
      subtitle: 'Graph Database + Vector Database Deep Integration',
      description: 'DAI 2.0 deeply integrates Oracle database\'s advanced data capabilities, supporting complex relationship paths, network analysis, fund flow chain analysis and other advanced business scenarios',
      features: [
        'Graph Database: Complex relationship paths, network analysis',
        'Vector Database: Unstructured text similarity search',
        'Automated Graph query logic generation',
        'Enterprise text data semantic retrieval'
      ],
      metrics: {
        capability: 'Multi-modal',
        analysis: 'Advanced',
        integration: 'Native'
      },
      demo: 'Analyze fund flow chain: Company A → Company B → Company C complete path'
    },

    agentTool: {
      title: 'Agent + Tool Smart Scheduling',
      subtitle: 'Task Decomposition + Dynamic Scheduling Architecture',
      description: 'DAI 2.0 builds a modular intelligent execution architecture based on Agent + Tool, achieving task intent recognition, task decomposition and dynamic scheduling',
      features: [
        'Task intent recognition: Automatically judge analysis complexity',
        'Task decomposition: Break complex tasks into multiple subtasks',
        'Tool scheduling: SQL, Graph, API tools intelligent scheduling',
        'Custom extension: Enterprise algorithms one-click registration as Tools'
      ],
      metrics: {
        automation: 'Intelligent',
        scalability: 'Scalable',
        integration: 'Seamless'
      },
      demo: 'Risk analysis = SQL Tool(financial tables) + Graph Tool(fund paths) + Vector Tool(sentiment text)'
    },

    simpleConfig: {
      title: 'Simple Configuration, Low Barrier Launch',
      subtitle: 'Out-of-the-box user experience',
      description: 'Brings "out-of-the-box" user experience - even without professional data engineers, DAI 2.0 can understand enterprise databases and start answering questions within minutes',
      features: [
        'Understand enterprise databases within minutes',
        'No need for professional data engineers',
        'Automatically identify data structures and relationships',
        'Zero-code configuration startup'
      ],
      metrics: {
        setup: 'Minutes',
        threshold: 'Zero barrier',
        expertise: 'No expertise required'
      },
      demo: 'Connect database → Auto-identify table structure → Start Q&A immediately'
    },

    comprehensiveAnalysis: {
      title: 'Comprehensive Analysis & Smart Reports',
      subtitle: 'Multi-source Multi-modal Data Linkage Analysis',
      description: 'Compared to traditional technology, DAI 2.0 first "digs deep" to link multi-source, multi-modal data, then outputs a directly actionable insight report',
      features: [
        'Multi-source data automatic correlation analysis',
        'Multi-modal data fusion processing',
        'Intelligent generation of decision insight reports',
        'Full-process automation from data to decisions'
      ],
      metrics: {
        sources: 'Multi-source',
        modality: 'Multi-modal',
        output: 'Decision-grade'
      },
      demo: 'Auto-generate: "Q4 Sales Decline Root Cause Analysis and Improvement Recommendations Report"'
    }
  },

  // Workflow process section
  workflowProcess: {
    title: 'DAI 2.0 Workflow',
    mainTitle: 'Full-Process Automation from Natural Language to Insight Reports',
    description: 'DAI 2.0 integrates "Multi-modal Oracle Data Capabilities" + "LLM Agent Scheduling" + "Zero-Barrier Auto Configuration" into a closed loop, completing full-process automation from natural language queries to insight reports.',

    oracleFeatures: {
      title: 'Oracle Advanced Features Native Support',
      graphDatabase: {
        title: 'Graph Database',
        description: 'Complex relationship paths, network analysis, fund flow chain analysis'
      },
      vectorDatabase: {
        title: 'Vector Database',
        description: 'Unstructured text, semantic search, similarity search'
      },
      traditionalSQL: {
        title: 'Traditional SQL',
        description: 'Structured data queries, statistical analysis, report generation'
      }
    },

    workflowSteps: {
      naturalLanguage: {
        title: 'Natural Language Querying',
        description: 'Users pose complex business questions in natural language',
        example: 'Analyze Company A\'s overall risk status, including financial, relationship, and sentiment aspects',
        details: [
          'Support for Chinese and English natural language',
          'Understand complex business scenarios',
          'Automatically identify analysis intent',
          'Assess task complexity'
        ]
      },
      taskDecomposition: {
        title: 'Task Decomposition + Dynamic Scheduling',
        description: 'Agent intelligently decomposes tasks and dynamically schedules multiple Tools',
        example: 'Task 1: SQL Tool → Task 2: Graph Tool → Task 3: Vector Tool',
        details: [
          'Task intent recognition',
          'Intelligent decomposition of complex tasks',
          'Multi-Tool collaborative scheduling',
          'Real-time execution monitoring'
        ]
      },
      multiToolExecution: {
        title: 'Multi-Task Execution',
        description: 'Multiple Tools execute in parallel, fusing multi-modal data',
        example: 'SQL + Graph + Vector data fusion analysis',
        details: [
          'SQL Tool: Financial data queries',
          'Graph Tool: Relationship path analysis',
          'Vector Tool: Sentiment text retrieval',
          'API Tool: External system integration'
        ]
      },
      insightReport: {
        title: 'Insight Report',
        description: 'Generate comprehensive analysis reports for direct decision-making',
        example: '"Company A Comprehensive Risk Assessment Report" - High risk, recommend suspending cooperation',
        details: [
          'Multi-source data comprehensive analysis',
          'Intelligent insight discovery',
          'Decision recommendation generation',
          'Visualization chart display'
        ]
      }
    },

    coreAdvantages: {
      title: 'Core Advantages of Agent + Tool Architecture',
      privateKnowledge: {
        title: 'Private Knowledge Rapid Cloud Migration',
        description: 'Enterprise expert experience one-click registration as Tools, no need to modify underlying code'
      },
      multiModalFusion: {
        title: 'Multi-Modal Data Fusion',
        description: 'SQL + Graph + Vector one-stop completion of complex analysis'
      },
      fastIteration: {
        title: 'Fast Iteration',
        description: 'Rapid response to new requirements, existing processes need no changes'
      }
    },

    exampleLabel: 'Example:'
  },

  // Core capabilities bottom statistics
  capabilitiesStats: {
    oracle: {
      number: 'Oracle',
      label: 'Native Deep Integration',
      description: 'Graph Database + Vector Database'
    },
    efficiency: {
      number: '10x',
      label: 'Efficiency Improvement',
      description: 'Compared to traditional BI tools'
    },
    accuracy: {
      number: '99.9%',
      label: 'Accuracy',
      description: 'Data analysis accuracy'
    },
    zeroCode: {
      number: '0-Code',
      label: 'Usage Barrier',
      description: 'Everyone can use'
    }
  },

  // AI Features Section
  aiFeatures: {
    badge: 'AI Intelligence Capabilities',
    title: 'Solving the Core Pain Point of "Large Models Working Alone"',
    description: 'DAI 2.0 uses Agent + Tool architecture to make data intelligence truly land in enterprises, achieving rapid cloud migration of private knowledge and multi-modal data fusion analysis',
    features: {
      privateKnowledge: {
        title: 'Private Knowledge Rapid Cloud Migration',
        description: 'Enterprise expert experience one-click registration as Tools, no need to modify underlying code',
        details: [
          'Financial expert SQL → One-click registration as finance_risk_score_tool',
          'Agent automatically schedules when business personnel ask questions',
          'No need to find DBA anymore, expert experience directly reused',
          'Enterprise knowledge assets rapidly digitized'
        ]
      },
      multimodalFusion: {
        title: 'Multi-Modal Data Fusion One-Stop Completion',
        description: 'Complex business problems solved through multiple Tool collaboration',
        details: [
          'Risk control problem = SQL Tool (financial table) + Graph Tool (fund path)',
          'Sentiment analysis = Vector Tool (sentiment text) + SQL Tool (business data)',
          'Agent responsible for decomposition and orchestration, unified output comprehensive report',
          'One question, multiple data sources, one answer'
        ]
      },
      fastIteration: {
        title: 'Fast Iteration Speed',
        description: 'Rapid response to new requirements, existing processes need no changes',
        details: [
          'New regulations require adding "Environmental Risk API"',
          'Just encapsulate as Tool and declare in configuration',
          'Existing Agent processes need no changes',
          'Business changes quickly adapted'
        ]
      },
      enterpriseReliability: {
        title: 'Enterprise-Grade Reliability',
        description: 'Solve large model hallucination problems, ensure analysis results are accurate and trustworthy',
        details: [
          'Based on RAG technology, data sources are traceable',
          'Enterprise knowledge base real-time update verification',
          'Multiple verification mechanisms ensure accuracy',
          'Analysis results are explainable and auditable'
        ]
      }
    },
    cta: {
      title: 'Experience Enterprise-Grade AI Data Intelligence Platform',
      description: 'DAI 2.0 makes enterprise data intelligence truly land, make your database "speak" in minutes, immediately start the Agent + Tool intelligent data journey',
      primary: 'Free Trial',
      secondary: 'Book Demo'
    }
  },

  // Comparison Analysis Section
  comparison: {
    badge: 'Comparison Analysis',
    title: 'DAI 2.0 vs Traditional BI Tools',
    description: 'Based on real demo cases, see how DAI 2.0 redefines the efficiency and depth of data analysis',
    traditional: {
      title: 'Traditional BI Tools'
    },
    dai: {
      title: 'DAI 2.0'
    },
    categories: {
      usage: {
        title: 'Usage Method',
        traditional: [
          { text: 'Need to learn SQL syntax', icon: '❌' },
          { text: 'Depend on technical support', icon: '❌' },
          { text: 'Preset report templates', icon: '❌' },
          { text: 'Manual data association', icon: '❌' }
        ],
        dai: [
          { text: 'Direct natural language queries', icon: '✅', example: '"What are the reasons for the sales decline in the past month?"' },
          { text: 'Business self-service analysis', icon: '✅', example: 'Zero-code barrier, instant Q&A' },
          { text: 'AI intelligent analysis generation', icon: '✅', example: 'Automatically decomposed into 5 analysis steps' },
          { text: 'Multi-dimensional automatic association', icon: '✅', example: 'Product→Brand→Promotion→Return full chain' }
        ]
      },
      depth: {
        title: 'Analysis Depth',
        traditional: [
          { text: 'Single-dimension queries', icon: '❌' },
          { text: 'Static report display', icon: '❌' },
          { text: 'Requires manual interpretation', icon: '❌' },
          { text: 'Lacks decision recommendations', icon: '❌' }
        ],
        dai: [
          { text: 'Multi-dimensional deep analysis', icon: '✅', example: 'Overall→Category→Brand→Promotion→Return' },
          { text: 'Smart chart generation', icon: '✅', example: 'Automatically generate visualization charts' },
          { text: 'AI intelligent insights', icon: '✅', example: 'Automatically identify key issues and trends' },
          { text: 'Generate decision recommendations', icon: '✅', example: 'Specific business action plans' }
        ]
      },
      technology: {
        title: 'Technical Capabilities',
        traditional: [
          { text: 'Single data source', icon: '❌' },
          { text: 'Fixed query logic', icon: '❌' },
          { text: 'Complex manual configuration', icon: '❌' },
          { text: 'Limited scalability', icon: '❌' }
        ],
        dai: [
          { text: 'Oracle multi-modal data fusion', icon: '✅', example: 'Relational + Graph + Vector databases' },
          { text: 'Agent intelligent scheduling', icon: '✅', example: 'Dynamically generate SQL query logic' },
          { text: 'Private knowledge rapid cloud migration', icon: '✅', example: 'Expert experience one-click registration' },
          { text: 'Tool ecosystem scalability', icon: '✅', example: 'Rapid response to new requirements' }
        ]
      }
    },
    realCase: {
      title: 'Real Case Comparison',
      question: 'What are the reasons for the sales decline in the past month?',
      traditionalTitle: 'Traditional BI Tools Process',
      daiTitle: 'DAI 2.0 Process',
      resultLabel: 'Result: ',
      traditionalProcess: [
        '1. Business personnel propose requirements',
        '2. Wait for technical personnel scheduling',
        '3. Write SQL query statements',
        '4. Manually generate multiple reports',
        '5. Manual data association analysis',
        '6. Write analysis reports',
        '⏱️ Time: 2-3 days'
      ],
      daiProcess: [
        '1. Direct natural language queries',
        '2. Agent intelligent task decomposition',
        '3. Automatically generate SQL queries',
        '4. Multi-dimensional data analysis',
        '5. Smart chart generation',
        '6. AI insight report output',
        '⚡ Time: 3 minutes'
      ],
      result: {
        traditional: 'Obtain basic data reports, requiring manual interpretation',
        dai: 'Obtain deep analysis reports + specific decision recommendations:\n• Computer category sales decreased by 2.14 million\n• Dell, Huawei and other brands performed poorly\n• Impact of May Day promotion ending\n• Recommend targeted promotion strategies'
      }
    },
    mobileHint: '💡 Tip: Swipe left and right to view different comparison dimensions, click cards to view detailed comparisons',
    moreAdvantages: 'more advantages',
    summary: {
      timeImprovement: 'From days to minutes',
      dataToDecision: 'From data to decisions',
      dependencyToSelfService: 'From dependency to self-service'
    }
  },

  // Common buttons and actions
  common: {
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    freeTrial: 'Free Trial',
    bookDemo: 'Book Demo',
    viewDetails: 'View Details',
    close: 'Close',
    demo: 'Demo Example',
    aiAnalyzing: 'AI Analyzing...',
    privateKnowledge: 'Private Knowledge',
    multimodalFusion: 'Multimodal Fusion',
    fastIteration: 'Fast Iteration',
    enterpriseReliable: 'Enterprise Reliable',
    dataEncryption: 'Data Encryption',
    accessControl: 'Access Control',
    auditLog: 'Audit Log',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    error: 'Something went wrong',
    retry: 'Retry',

    // Data types
    structured: 'Structured',
    graphData: 'Graph Data',
    vector: 'Vector',

    // Development process
    requirementAnalysis: 'Requirement Analysis',
    rapidDevelopment: 'Rapid Development',
    testing: 'Testing & Validation',
    deployment: 'Deployment',

    // Performance metrics
    accuracy: 'Accuracy',
    availability: 'Availability',
    responseTime: 'Response Time',
    securityLevel: 'Security Level'
  },

  // Video Player
  video: {
    title: 'Product Demo Video',
    unsupported: 'Your browser does not support video playback',
    openInNewWindow: 'Watch in New Window',
    download: 'Download',
    playbackSpeed: 'Playback Speed',
    pictureInPicture: 'Picture in Picture'
  },

  // Product Page
  product: {
    seo: {
      title: 'Product Overview - DecisionAI 2.0 | Enterprise AI Data Intelligence Platform',
      description: 'Discover DecisionAI 2.0\'s core features, Agent + Tool intelligent scheduling architecture, Oracle native support, natural language interaction and other enterprise-level AI data analysis capabilities.'
    },
    hero: {
      badge: 'DecisionAI 2.0 Product Overview',
      title: 'Redefining',
      titleHighlight: ' AI Data Analytics',
      subtitle: 'Based on Agent + Tool architecture, deeply integrated with Oracle advanced features, achieving full automation from natural language queries to insight reports',
      cta: {
        trial: 'Free Trial',
        demo: 'Book Demo'
      }
    },
    features: {
      title: 'Core Features',
      subtitle: 'Four core capabilities that make data intelligence truly land in enterprises',
      items: {
        nlp: {
          title: 'Natural Language Interaction',
          description: 'Query data like chatting, zero coding barrier',
          details: [
            'Support Chinese and English natural language queries',
            'Intelligent understanding of complex business scenarios',
            'Multi-turn conversation context memory',
            'Automatic error correction and clarification mechanism'
          ]
        },
        agent: {
          title: 'Agent + Tool Intelligent Scheduling',
          description: 'Task decomposition + dynamic scheduling architecture',
          details: [
            'Intelligent task decomposition and planning',
            'Multi-tool collaborative work',
            'Dynamic resource scheduling optimization',
            'Real-time execution status monitoring'
          ]
        },
        oracle: {
          title: 'Oracle Native Support',
          description: 'Graph database + vector database deep integration',
          details: [
            'Native support for Oracle advanced features',
            'Graph database complex relationship analysis',
            'Vector database semantic retrieval',
            'Multi-modal data fusion processing'
          ]
        },
        config: {
          title: 'Minimal Configuration Deployment',
          description: 'Out-of-the-box user experience',
          details: [
            'Understand enterprise databases in minutes',
            'No professional data engineers required',
            'Automatic identification of data structure and relationships',
            'Zero-code configuration startup'
          ]
        }
      }
    },
    useCases: {
      title: 'Use Cases',
      subtitle: 'Professional AI data analysis solutions tailored to different industry characteristics',
      items: {
        ecommerce: {
          title: 'E-commerce & Retail',
          description: 'Intelligent user profiling, hit product prediction, advertising optimization',
          benefits: ['Member ARPU increased by 15%', 'Hit product identification accuracy 85%', 'Advertising ROI increased by 25%']
        },
        finance: {
          title: 'Financial Services',
          description: 'Risk assessment, anti-fraud, intelligent investment advisory',
          benefits: ['Risk identification accuracy 95%', 'Fraud detection efficiency increased by 80%', 'Investment advice accuracy 90%']
        },
        manufacturing: {
          title: 'Manufacturing',
          description: 'Supply chain optimization, quality control, predictive maintenance',
          benefits: ['Inventory cost reduced by 20%', 'Quality issues reduced by 60%', 'Equipment failure prediction accuracy 85%']
        }
      }
    },
    cta: {
      title: 'Ready to Experience DecisionAI 2.0?',
      subtitle: 'Make your Oracle database "speak" in minutes',
      buttons: {
        trial: 'Start Free Trial',
        demo: 'Book Product Demo'
      }
    }
  },

  // Solutions Page
  solutions: {
    seo: {
      title: 'Solutions - DecisionAI 2.0 | Industry AI Data Analysis Solutions',
      description: 'DecisionAI 2.0 provides professional AI data analysis solutions for e-commerce, financial services, manufacturing and other industries to help enterprises with digital transformation.'
    },
    hero: {
      badge: 'Industry Solutions',
      title: 'Tailored for',
      titleHighlight: ' Different Industries',
      subtitle: 'Based on deep industry understanding, providing professional AI data analysis solutions for e-commerce, financial services, manufacturing and other industries'
    },
    industries: {
      ecommerce: {
        name: 'E-commerce & Retail',
        title: 'AI-Driven Intelligent Business Decisions',
        description: 'Conversational data analysis, making every operator a data expert',
        challenges: [
          'Traditional BI tools are slow to respond, business users depend on technical teams',
          'Data analysis cycle takes 2-3 days, missing business opportunities',
          'Lack of real-time insights, difficult to quickly adjust strategies'
        ],
        solutions: [
          {
            title: 'Intelligent User Profiling',
            description: 'AI automatically analyzes user behavior to accurately identify high-value customers',
            result: 'Member ARPU increased by 15%'
          },
          {
            title: 'Hit Product Prediction',
            description: 'Based on historical data and market trends, AI predicts potential hit products',
            result: 'Hit product identification accuracy 85%'
          },
          {
            title: 'Intelligent Ad Optimization',
            description: 'AI optimizes advertising strategies in real-time to reduce customer acquisition costs',
            result: 'Advertising ROI increased by 25%'
          }
        ],
        caseStudy: {
          company: 'A Leading E-commerce Platform',
          description: 'Daily order volume 1M+, requiring real-time analysis of user behavior and sales trends',
          results: [
            'Analysis efficiency improved by 60%, from days to minutes',
            'Decision time reduced by 90%, from 2-3 days to 3 minutes',
            'Self-service analysis rate increased by 80%, business users complete analysis independently'
          ]
        }
      },
      finance: {
        name: 'Financial Services',
        title: 'AI-Driven Intelligent Risk Control Decisions',
        description: 'Real-time risk assessment, intelligent anti-fraud, precise investment advice',
        challenges: [
          'Risk assessment relies on manual experience, low efficiency',
          'Fraud detection lags, losses are difficult to recover',
          'Investment decisions lack data support'
        ],
        solutions: [
          {
            title: 'Intelligent Risk Assessment',
            description: 'Multi-dimensional data fusion, real-time assessment of customer risk levels',
            result: 'Risk identification accuracy 95%'
          },
          {
            title: 'Anti-Fraud Detection',
            description: 'AI models monitor abnormal transactions in real-time, quickly identifying fraudulent behavior',
            result: 'Fraud detection efficiency increased by 80%'
          },
          {
            title: 'Intelligent Investment Advisory',
            description: 'Based on market data and user profiles, providing personalized investment advice',
            result: 'Investment advice accuracy 90%'
          }
        ],
        caseStudy: {
          company: 'A Major Bank',
          description: 'Serving over 10 million customers, requiring real-time risk control and intelligent decisions',
          results: [
            'Risk assessment efficiency improved by 70%',
            'Fraud losses reduced by 85%',
            'Customer satisfaction increased by 40%'
          ]
        }
      },
      manufacturing: {
        name: 'Manufacturing',
        title: 'AI-Enabled Intelligent Manufacturing Decisions',
        description: 'Supply chain optimization, quality control, predictive maintenance',
        challenges: [
          'Complex supply chain management, high inventory costs',
          'Quality issues discovered late, affecting production efficiency',
          'Equipment maintenance relies on experience, difficult to predict failures'
        ],
        solutions: [
          {
            title: 'Supply Chain Optimization',
            description: 'AI analyzes supply and demand relationships, optimizing inventory configuration and procurement plans',
            result: 'Inventory cost reduced by 20%'
          },
          {
            title: 'Intelligent Quality Control',
            description: 'Real-time monitoring of production data, predicting and preventing quality issues',
            result: 'Quality issues reduced by 60%'
          },
          {
            title: 'Predictive Maintenance',
            description: 'AI analyzes equipment operation data, predicting failures and performing proactive maintenance',
            result: 'Equipment failure prediction accuracy 85%'
          }
        ],
        caseStudy: {
          company: 'A Leading Manufacturing Enterprise',
          description: 'With 50+ production lines, requiring intelligent management and optimization',
          results: [
            'Production efficiency improved by 30%',
            'Maintenance costs reduced by 25%',
            'Product quality improved by 45%'
          ]
        }
      },
      franchise: {
        name: 'Chain Franchise',
        title: 'Chain Franchise Industry Solutions',
        description: 'AI-powered intelligent decision system for chain franchise management, helping franchisees achieve refined operations and rapid expansion',
        challenges: [
          'Lack of scientific site evaluation system, high decision-making risk',
          'Large operational gaps between franchisees, difficult standardization',
          'Dispersed franchise data, difficult unified management and analysis',
          'Rapid expansion brings management challenges and quality control issues'
        ],
        solutions: [
          {
            title: 'Smart Site Selection',
            description: 'Multi-dimensional data analysis to evaluate optimal store locations',
            result: '35% increase in new store success rate'
          },
          {
            title: 'Franchise Operations',
            description: 'Data-driven refined management to improve overall operational efficiency',
            result: '20% improvement in average franchise revenue'
          },
          {
            title: 'Expansion Strategy',
            description: 'Scientific expansion planning to reduce investment risks',
            result: '40% reduction in site selection decision time'
          }
        ],
        caseStudy: {
          company: 'A Well-known Restaurant Chain Brand',
          description: 'Managing 500+ franchise stores nationwide, requiring scientific site selection and refined operations',
          results: [
            '35% increase in new store success rate',
            '20% improvement in average franchise revenue',
            '40% reduction in site selection decision time'
          ]
        }
      }
    },
    common: {
      challenges: 'Challenges',
      solutions: 'DAI 2.0 Solutions',
      caseStudy: 'Customer Success Story',
      quantifiedResults: 'Quantified Results',
      learnMore: 'Learn More'
    },
    cta: {
      title: 'Want to Learn About Your Industry Solution?',
      subtitle: 'Contact our experts to get customized industry solutions',
      buttons: {
        consultation: 'Book Expert Consultation',
        trial: 'Free Trial'
      }
    }
  },

  // Cases Page
  cases: {
    seo: {
      title: 'Customer Cases - DecisionAI 2.0 | Real Customer Success Stories',
      description: 'View real customer success stories of DecisionAI 2.0 in e-commerce, financial services, manufacturing and other industries, learn about quantified results and customer testimonials.'
    },
    hero: {
      badge: 'Customer Success Stories',
      title: 'Real Customer',
      titleHighlight: ' Success Stories',
      subtitle: 'See how customers from different industries achieve data intelligence transformation through DecisionAI 2.0 and obtain significant business results'
    },
    stats: [
      { number: '500+', label: 'Enterprise Clients', description: 'Across All Industries' },
      { number: '3 Minutes', label: 'Average Analysis Time', description: 'From Question to Insight' },
      { number: '90%', label: 'Efficiency Improvement', description: 'Compared to Traditional Methods' },
      { number: '99.9%', label: 'Accuracy Rate', description: 'AI Analysis Accuracy' }
    ],
    filters: [
      { id: 'all', name: 'All Cases' },
      { id: 'ecommerce', name: 'E-commerce & Retail' },
      { id: 'finance', name: 'Financial Services' },
      { id: 'manufacturing', name: 'Manufacturing' },
      { id: 'logistics', name: 'Logistics & Transportation' }
    ],
    caseStudies: [
      {
        id: 1,
        category: 'ecommerce',
        company: 'A Leading E-commerce Platform',
        industry: 'E-commerce & Retail',
        logo: '🛒',
        challenge: 'Daily order volume 1M+, traditional BI tools are slow to respond, business users depend on technical teams, analysis cycle takes 2-3 days',
        solution: 'DAI 2.0 Agent + Tool architecture, natural language queries, intelligent task decomposition',
        results: [
          { metric: 'Analysis Efficiency', improvement: 'Improved 60%', detail: 'From days to minutes' },
          { metric: 'Decision Time', improvement: 'Reduced 90%', detail: 'From 2-3 days to 3 minutes' },
          { metric: 'Self-service Analysis Rate', improvement: 'Improved 80%', detail: 'Business users complete analysis independently' }
        ],
        testimonial: {
          quote: 'DAI 2.0 enabled our operations team to independently complete complex data analysis for the first time. From questions like "What are the reasons for the sales decline in the past month?" to getting complete reports with specific decision recommendations, it only takes 3 minutes.',
          author: 'Data Operations Director',
          company: 'A Leading E-commerce Platform'
        }
      },
      {
        id: 2,
        category: 'finance',
        company: 'A Well-known Bank',
        industry: 'Financial Services',
        logo: '🏦',
        challenge: 'Risk assessment relies on manual experience, fraud detection lags, investment decisions lack data support',
        solution: 'Multi-dimensional risk assessment model, real-time anti-fraud detection, intelligent investment advisory services',
        results: [
          { metric: 'Risk Identification Accuracy', improvement: 'Reached 95%', detail: 'Multi-dimensional data fusion analysis' },
          { metric: 'Fraud Detection Efficiency', improvement: 'Improved 80%', detail: 'Real-time monitoring of abnormal transactions' },
          { metric: 'Customer Satisfaction', improvement: 'Improved 40%', detail: 'Personalized investment advice' }
        ],
        testimonial: {
          quote: 'Through DecisionAI 2.0, we achieved intelligent upgrade of risk management, not only improving the accuracy of risk identification, but also significantly enhancing customer service quality.',
          author: 'Risk Management Director',
          company: 'A Well-known Bank'
        }
      },
      {
        id: 3,
        category: 'manufacturing',
        company: 'A Leading Manufacturing Enterprise',
        industry: 'Manufacturing',
        logo: '🏭',
        challenge: 'Complex supply chain management, late discovery of quality issues, equipment maintenance relies on experience',
        solution: 'Intelligent supply chain optimization, quality prediction control, predictive maintenance system',
        results: [
          { metric: 'Production Efficiency', improvement: 'Improved 30%', detail: 'Intelligent production management' },
          { metric: 'Maintenance Cost', improvement: 'Reduced 25%', detail: 'Predictive maintenance' },
          { metric: 'Product Quality', improvement: 'Improved 45%', detail: 'Real-time quality monitoring' }
        ],
        testimonial: {
          quote: 'DAI 2.0 helped us achieve the transformation from traditional manufacturing to intelligent manufacturing, with significant improvements in production efficiency and product quality.',
          author: 'Production Operations Director',
          company: 'A Leading Manufacturing Enterprise'
        }
      },
      {
        id: 4,
        category: 'logistics',
        company: 'A Logistics Group',
        industry: 'Logistics & Transportation',
        logo: '🚚',
        challenge: 'Complex route planning, high transportation costs, untimely cargo tracking',
        solution: 'Intelligent route optimization, cost prediction analysis, real-time cargo tracking',
        results: [
          { metric: 'Transportation Efficiency', improvement: 'Improved 35%', detail: 'Intelligent route planning' },
          { metric: 'Transportation Cost', improvement: 'Reduced 20%', detail: 'Cost optimization analysis' },
          { metric: 'Customer Satisfaction', improvement: 'Improved 50%', detail: 'Real-time tracking service' }
        ],
        testimonial: {
          quote: 'Through AI data analysis, our logistics network has become more intelligent and efficient, and customer experience has also been greatly improved.',
          author: 'Vice President of Operations',
          company: 'A Logistics Group'
        }
      }
    ],
    common: {
      challenge: 'Challenges',
      solution: 'Solutions',
      results: 'Quantified Results'
    },
    cta: {
      title: 'Become the Next Success Story',
      subtitle: 'Join 500+ enterprise customers and start your data intelligence journey',
      buttons: {
        trial: 'Free Trial',
        demo: 'Book Demo'
      }
    }
  },

  // Pricing Page
  pricing: {
    seo: {
      title: 'Pricing Plans - DecisionAI 2.0 | Flexible Enterprise AI Data Analysis Pricing',
      description: 'View DecisionAI 2.0 pricing plans, from free to enterprise editions, meeting AI data analysis needs for enterprises of all sizes. 14-day free trial.'
    },
    hero: {
      badge: 'Pricing Plans',
      title: 'Choose the Right',
      titleHighlight: ' Pricing Plan',
      subtitle: 'From free trial to enterprise solutions, we provide flexible pricing options for enterprises of all sizes'
    },
    billing: {
      monthly: 'Monthly Billing',
      yearly: 'Annual Billing',
      yearlyDiscount: 'Save 20%'
    },
    plans: [
      {
        name: 'Free',
        price: { monthly: 0, yearly: 0 },
        description: 'Perfect for individuals and small teams to try',
        features: [
          '100 queries per month',
          'Basic data analysis',
          'Standard chart generation',
          'Email support',
          'Data export functionality'
        ],
        limitations: [
          'No advanced AI models',
          'No custom integrations',
          'Data storage limited to 1GB'
        ],
        cta: 'Get Started Free',
        popular: false,
        variant: 'outline'
      },
      {
        name: 'Professional',
        price: { monthly: 299, yearly: 2990 },
        description: 'Perfect for SMEs and professional teams',
        features: [
          '10,000 queries per month',
          'Advanced AI data analysis',
          'Natural language interaction',
          'Agent + Tool intelligent scheduling',
          'Multiple charts and reports',
          'Priority technical support',
          '100GB data storage',
          'API access',
          'Team collaboration features'
        ],
        limitations: [],
        cta: 'Buy Now',
        popular: true,
        variant: 'primary'
      },
      {
        name: 'Enterprise',
        price: { monthly: 999, yearly: 9990 },
        description: 'Perfect for large enterprises and complex business scenarios',
        features: [
          'Unlimited queries',
          'Enterprise-grade AI data analysis',
          'Oracle native deep integration',
          'Private knowledge base cloud',
          'Multi-modal data fusion analysis',
          '7x24 dedicated support',
          'Unlimited data storage',
          'Advanced API and integrations',
          'Single Sign-On (SSO)',
          'Data security compliance',
          'Custom development',
          'Dedicated customer success manager'
        ],
        limitations: [],
        cta: 'Buy Now',
        popular: false,
        variant: 'outline'
      }
    ],
    features: [
      {
        category: 'Core Features',
        items: [
          { name: 'Natural Language Queries', free: '✓', pro: '✓', enterprise: '✓' },
          { name: 'Agent + Tool Intelligent Scheduling', free: '✗', pro: '✓', enterprise: '✓' },
          { name: 'Oracle Native Support', free: '✗', pro: 'Basic', enterprise: 'Advanced' },
          { name: 'Multi-modal Data Fusion', free: '✗', pro: '✓', enterprise: '✓' },
          { name: 'Private Knowledge Base', free: '✗', pro: '✗', enterprise: '✓' }
        ]
      },
      {
        category: 'Usage Limits',
        items: [
          { name: 'Monthly Queries', free: '100', pro: '10,000', enterprise: 'Unlimited' },
          { name: 'Data Storage', free: '1GB', pro: '100GB', enterprise: 'Unlimited' },
          { name: 'Number of Users', free: '1', pro: '10', enterprise: 'Unlimited' },
          { name: 'API Calls', free: '✗', pro: '1,000/month', enterprise: 'Unlimited' }
        ]
      },
      {
        category: 'Support Services',
        items: [
          { name: 'Technical Support', free: 'Email', pro: 'Priority Support', enterprise: '7x24 Dedicated' },
          { name: 'Training Services', free: '✗', pro: 'Online Training', enterprise: 'On-site Training' },
          { name: 'Custom Development', free: '✗', pro: '✗', enterprise: '✓' },
          { name: 'Customer Success Manager', free: '✗', pro: '✗', enterprise: '✓' }
        ]
      }
    ],
    faqs: [
      {
        question: 'Can I try it for free?',
        answer: 'Yes, we offer a free version with basic features. Professional and Enterprise editions also offer a 14-day free trial.'
      },
      {
        question: 'How do I upgrade or downgrade my plan?',
        answer: 'You can upgrade or downgrade your plan anytime in account settings. Changes will take effect in the next billing cycle.'
      },
      {
        question: 'What payment methods are supported?',
        answer: 'We support credit cards, bank transfers, Alipay and other payment methods. Enterprise customers can apply for invoices.'
      },
      {
        question: 'How is data security guaranteed?',
        answer: 'We use enterprise-grade security measures including data encryption, access control, security audits, etc., to ensure your data security.'
      },
      {
        question: 'Can I cancel my subscription?',
        answer: 'You can cancel your subscription at any time. After cancellation, you can still use it until the end of the current billing cycle.'
      }
    ],
    common: {
      popular: 'Most Popular',
      month: 'month',
      year: 'year',
      mobileHint: '💡 Tip: Swipe left to see more plans, or use the feature comparison below to see detailed differences',
      featureComparison: 'Feature Comparison',
      featureComparisonDesc: 'Learn about the feature differences between versions in detail',
      faq: 'Frequently Asked Questions',
      faqDesc: 'Common questions and answers about pricing and services',
      featuresIncluded: 'Features Included:',
      limitations: 'Limitations:'
    },
    cta: {
      title: 'Ready to Start Your Data Intelligence Journey?',
      subtitle: 'Start your 14-day free trial now, no credit card required',
      buttons: {
        trial: 'Free Trial',
        contact: 'Contact Sales'
      }
    }
  },

  // Resources Page
  resources: {
    seo: {
      title: 'Resource Center - DecisionAI 2.0 | Documentation, Guides, API and Technical Resources',
      description: 'Get complete resources for DecisionAI 2.0, including product documentation, user guides, API documentation, technical blogs and video tutorials.'
    },
    hero: {
      badge: 'Resource Center',
      title: 'Learning Resources',
      titleHighlight: ' One-Stop Access',
      subtitle: 'From product documentation to technical blogs, from API references to video tutorials, get all the resources you need'
    },
    featured: {
      title: 'Featured Resources',
      subtitle: 'Most popular and valuable learning resources'
    },
    categories: [
      { id: 'all', name: 'All Resources' },
      { id: 'docs', name: 'Product Documentation' },
      { id: 'guides', name: 'User Guides' },
      { id: 'api', name: 'API Documentation' },
      { id: 'blog', name: 'Technical Blog' },
      { id: 'videos', name: 'Video Tutorials' }
    ],
    resourceList: [
      {
        id: 1,
        category: 'docs',
        type: 'Product Documentation',
        title: 'DecisionAI 2.0 Product Introduction',
        description: 'Comprehensive understanding of DecisionAI 2.0 core features, technical architecture and application scenarios',
        format: 'PDF',
        size: '2.5MB',
        downloadUrl: '#',
        readTime: '15 minutes',
        featured: true
      },
      {
        id: 2,
        category: 'guides',
        type: 'Quick Start',
        title: '5-Minute Quick Start Guide',
        description: 'From zero to hero, quickly master the basic usage of DecisionAI 2.0',
        format: 'PDF',
        size: '1.8MB',
        downloadUrl: '#',
        readTime: '5 minutes',
        featured: true
      },
      {
        id: 3,
        category: 'api',
        type: 'API Documentation',
        title: 'REST API Reference Manual',
        description: 'Complete API interface documentation, including request parameters, response formats and sample code',
        format: 'Online Documentation',
        size: '-',
        downloadUrl: '#',
        readTime: '30 minutes',
        featured: false
      },
      {
        id: 4,
        category: 'guides',
        type: 'Deployment Guide',
        title: 'Enterprise Deployment Best Practices',
        description: 'Detailed deployment guide including security configuration, performance optimization and troubleshooting',
        format: 'PDF',
        size: '3.2MB',
        downloadUrl: '#',
        readTime: '25 minutes',
        featured: false
      },
      {
        id: 5,
        category: 'blog',
        type: 'Technical Blog',
        title: 'Agent + Tool Architecture Deep Dive',
        description: 'In-depth analysis of DecisionAI 2.0 core architecture design philosophy and technical implementation',
        format: 'Online Article',
        size: '-',
        downloadUrl: '#',
        readTime: '12 minutes',
        featured: true
      },
      {
        id: 6,
        category: 'videos',
        type: 'Video Tutorial',
        title: 'Product Demo Video Collection',
        description: 'Learn about DecisionAI 2.0 applications in different scenarios through real case demonstrations',
        format: 'Video',
        size: '120MB',
        downloadUrl: '#',
        readTime: '45 minutes',
        featured: false
      },
      {
        id: 7,
        category: 'docs',
        type: 'Technical Whitepaper',
        title: 'Enterprise AI Data Analysis Whitepaper',
        description: 'In-depth analysis of development trends, technical challenges and solutions for enterprise AI data analysis',
        format: 'PDF',
        size: '4.1MB',
        downloadUrl: '#',
        readTime: '35 minutes',
        featured: false
      },
      {
        id: 8,
        category: 'guides',
        type: 'Integration Guide',
        title: 'Oracle Database Integration Guide',
        description: 'Detailed instructions on how to deeply integrate DecisionAI 2.0 with Oracle database',
        format: 'PDF',
        size: '2.8MB',
        downloadUrl: '#',
        readTime: '20 minutes',
        featured: false
      }
    ],
    common: {
      readTime: 'Read Time',
      size: 'Size',
      getResource: 'Get Resource',
      get: 'Get',
      featured: 'Featured'
    },
    help: {
      title: 'Need More Help?',
      subtitle: 'Our technical team is always ready to support you and help you better use DecisionAI 2.0',
      support: {
        email: {
          title: 'Email Support',
          contact: 'support@decisionai.com'
        },
        chat: {
          title: 'Online Support',
          hours: 'Weekdays 9:00-18:00'
        },
        phone: {
          title: 'Phone Support',
          number: '400-898-7779'
        }
      },
      buttons: {
        contact: 'Contact Technical Support',
        training: 'Book Training'
      }
    }
  },

  // Customer Cases
  customerCases: {
    badge: 'Customer Success Stories',
    title: 'Real Customer Cases & Results',
    subtitle: 'Based on real demonstration scenarios, see how customers from different industries achieve data intelligence transformation through DAI 2.0',
    mobileHint: '💡 Tip: Swipe left and right to view cases from different industries, tap cards to see detailed results',
    stats: {
      clients: 'Enterprise Clients',
      analysisTime: 'Average Analysis Time',
      efficiency: 'Efficiency Improvement',
      minute: 'min'
    },
    industries: {
      ecommerce: 'E-commerce',
      finance: 'Financial Services',
      manufacturing: 'Manufacturing'
    },
    cases: {
      ecommerce: {
        company: 'Major E-commerce Platform',
        industry: 'E-commerce',
        background: '1M+ daily orders, requiring real-time analysis of user behavior and sales trends',
        challenge: 'Traditional BI tools are slow to respond, business users depend on technical teams, analysis cycle takes 2-3 days',
        solution: 'DAI 2.0 Agent + Tool architecture, natural language queries, intelligent task decomposition',
        results: [
          { metric: 'Analysis Efficiency', improvement: '60% Improvement', detail: 'From days to minutes' },
          { metric: 'Decision Time', improvement: '90% Reduction', detail: 'From 2-3 days to 3 minutes' },
          { metric: 'Self-service Analysis', improvement: '80% Improvement', detail: 'Business users complete analysis independently' }
        ],
        testimonial: 'DAI 2.0 enables our operations team to independently complete complex data analysis for the first time. From questions like "What are the reasons for sales decline in the past month?" to getting complete reports with specific decision recommendations, it only takes 3 minutes.',
        person: 'Data Operations Director',
        realExample: {
          question: 'What are the reasons for sales decline in the past month?',
          analysis: 'Agent intelligently decomposes into 5 steps: Overall trend → Product category → Brand dimension → Promotion impact → Return analysis',
          insight: 'Found that computer category sales dropped by 2.14 million, Dell and Huawei brands performed poorly, mainly due to the end of May Day promotions',
          recommendation: 'Recommend targeted promotional strategies for computer category, focusing on Dell and Huawei brand market performance'
        }
      },
      finance: {
        company: 'Financial Institution',
        industry: 'Financial Services',
        background: 'Complex risk control analysis needs involving multi-source data and relationship analysis',
        challenge: 'Complex relationship analysis requires professional data analysts, long risk identification cycles',
        solution: 'Oracle graph database + vector database deep integration, multi-Tool collaborative analysis',
        results: [
          { metric: 'Risk Identification Accuracy', improvement: '25% Improvement', detail: 'Multi-modal data fusion analysis' },
          { metric: 'Analysis Dimensions', improvement: '3x Expansion', detail: 'From single to multi-modal data' },
          { metric: 'Expert Experience Reuse', improvement: '100% Improvement', detail: 'One-click registration as Tool' }
        ],
        testimonial: 'Through DAI 2.0\'s Agent + Tool architecture, we can simultaneously call SQL Tool, Graph Tool, and Vector Tool to achieve one-stop analysis of financial data, relationships, and sentiment text.',
        person: 'Risk Control Department Head',
        realExample: {
          question: 'Analyze Company A\'s overall risk status',
          analysis: 'Agent dispatches SQL Tool to query financial data, Graph Tool to analyze relationships, Vector Tool to retrieve sentiment text',
          insight: 'Found Company A has abnormal financial indicators, complex related transaction paths, and negative information in sentiment',
          recommendation: 'Comprehensive risk assessment is high risk, recommend suspending cooperation and strengthening monitoring'
        }
      },
      manufacturing: {
        company: 'Manufacturing Enterprise',
        industry: 'Manufacturing',
        background: 'Scattered supply chain data, experience-dependent decisions, lack of unified analysis platform',
        challenge: 'Serious data silos, lack of unified analysis platform, difficult to inherit expert experience',
        solution: 'Private knowledge rapid cloud deployment, multi-Tool collaboration, expert experience one-click registration',
        results: [
          { metric: 'Supply Chain Transparency', improvement: '40% Improvement', detail: 'Full-chain data integration' },
          { metric: 'Inventory Optimization', improvement: '15% Cost Savings', detail: 'Intelligent prediction and recommendations' },
          { metric: 'Data-driven Decisions', improvement: '70% Improvement', detail: 'From experience to data-driven' }
        ],
        testimonial: 'DAI 2.0 enables our supply chain expert experience to be quickly digitized, and new employees can also obtain professional-level analysis results through natural language Q&A.',
        person: 'Supply Chain Director',
        realExample: {
          question: 'Optimize inventory configuration to reduce costs',
          analysis: 'Call supply chain expert Tool, analyze historical data and market trends, predict demand changes',
          insight: 'Found some raw materials are overstocked, some products have obvious seasonal demand fluctuations',
          recommendation: 'Adjust inventory strategy, optimize procurement plan, expected to save 15% costs'
        }
      }
    },
    labels: {
      background: 'Project Background',
      challenge: 'Challenges Faced',
      solution: 'DAI 2.0 Solution',
      results: 'Quantified Results',
      testimonial: 'Customer Testimonial',
      realAnalysis: 'Real Analysis Case',
      analysisQuestion: 'Analysis Question',
      agentProcess: 'Agent + Tool Analysis Process',
      insights: 'Intelligent Insights',
      recommendations: 'Decision Recommendations',
      moreResults: 'More Results',
      viewDetails: 'View Details',
      collapse: 'Collapse'
    }
  },

  // Data-Driven Decision Section
  dataDecision: {
    title: 'Everyone, Every Enterprise, Needs Data-Driven Decisions',
    scenarios: {
      onlineAds: {
        title: 'Online Advertising',
        description: 'Real-time data analysis helps improve ad ROI',
        features: [
          'Ad Placement',
          'Live Streaming Ads'
        ]
      },
      ecommerce: {
        title: 'E-commerce Retail',
        description: 'Data-driven precise decisions, accelerated growth',
        features: [
          'Member Management',
          'Hit Product Creation',
          'Channel Management',
          'User Acquisition & Retention'
        ]
      },
      manufacturing: {
        title: 'Manufacturing',
        description: 'Agile analysis of complex data, improved operations',
        features: [
          'Supply Chain Management',
          'WeChat Marketing'
        ]
      },
      franchise: {
        title: 'Chain Franchise',
        description: 'Real-time data sharing and queries, enhanced cooperation',
        features: [
          'Franchise Management',
          'ROI Management'
        ]
      }
    }
  },

  // Footer
  footer: {
    quickLinks: 'Quick Links',
    contactUs: 'Contact Us',
    aboutUs: 'About Us',
    phone: '400-898-7779',
    copyright: 'Cheetah Mobile© 2025',
    decisionAICopyright: '© 2025 DecisionAI',
    privacyPolicy: 'Privacy Policy',
    orionStar: 'Orion Star',
    qrCodeAlt: 'QR Code',
    wechatQR: 'WeChat Official Account',
    productServices: 'Products & Services',
    companyInfo: 'DecisionAI 2.0 - Make Your Data Speak, Make Decisions Smarter. Agent + Tool Smart Scheduling Architecture, Turn Oracle Database into AI Assistant in 3 Minutes.',
    coreFeatures: 'Core Features',
    industrySolutions: 'Industry Solutions'
  },

  // Demo Conversation Content
  conversations: {
    retail_1: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "What are the reasons for the sales decline in the past month?",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nAnalyze possible reasons for sales decline in the past month by comparing recent and previous sales data, and investigating anomalies from product, promotion, and return dimensions.\n\n📋 **Execution Plan**\n1. Calculate overall sales trend changes\n2. Multi-dimensional deep analysis (product categories, brands, promotions)\n3. Generate comprehensive analysis report and decision recommendations",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Overall Trend Analysis",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 1.168 ms**\n\n```sql\nSELECT SUM(payment_amount) AS recent_month_sales,\n(SELECT SUM(payment_amount) FROM orders \n WHERE order_date >= DATE_SUB('2025-06-11', INTERVAL 2 MONTH)\n AND order_date < DATE_SUB('2025-06-11', INTERVAL 1 MONTH))\nAS previous_month_sales FROM orders\nWHERE order_date >= DATE_SUB('2025-06-11', INTERVAL 1 MONTH)\n```\n\n📊 **Query Results**\n• Recent month sales: 27,047,017 yuan\n• Previous month sales: 27,918,177 yuan\n• **Sales decrease: 871,160 yuan (3.1%)**\n\n📈 **Smart Chart Analysis**\nTrend chart generated",
          description: "SQL Tool executes data query to confirm sales decline trend",
          chart: "line"
        },
        step3: {
          phase: "Multi-dimensional Deep Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Product Category Analysis** (Duration: 1.029 ms)\n• **Computer Category**: 11,140,872 yuan (decreased by 2,144,037 yuan) ⚠️\n• **Mobile Phone Category**: 8,397,633 yuan (increased by 408,313 yuan) ✅\n• **Tablet Category**: 5,289,652 yuan (increased by 595,749 yuan) ✅\n• **Smart Wearables**: 2,218,860 yuan (increased by 268,815 yuan) ✅\n\n🏷️ **Brand Dimension Analysis** (Duration: 0.957 ms)\n• **Dell**: 2,682,011 yuan (decreased by 857,601 yuan) ⚠️\n• **Huawei**: 2,863,268 yuan (decreased by 178,621 yuan) ⚠️\n• **Lenovo**: 2,574,447 yuan (decreased by 129,369 yuan) ⚠️\n• **Apple**: 9,467,175 yuan (decreased by 98,225 yuan) ⚠️\n\n🎯 **Promotion Impact Analysis** (Duration: 0.878 ms)\n• **May Day Promotion End Impact**: 752,247 yuan\n• **Return Situation Improvement**: Not a decline factor\n\n🎯 **Key Findings**\n**Computer category sales declined significantly**, Dell brand performed worst\n\n📈 **Smart Chart Analysis**\nMulti-dimensional analysis chart generated",
          description: "Agent schedules multi-tool parallel analysis for comprehensive problem diagnosis",
          chart: "bar"
        },
        step4: {
          phase: "Comprehensive Analysis Report",
          ai: "📋 **Sales Decline Analysis Report**\n\n🎯 **Core Conclusions**\nSales decreased by 3.1% in the past month, main reasons:\n\n⚠️ **Main Reasons**\n1. **Computer category sales declined significantly** (decreased by 2.14 million yuan)\n2. **Dell brand performed worst** (decreased by 860,000 yuan)\n3. **May Day promotion ended** (impact of 750,000 yuan)\n\n💡 **Decision Recommendations**\n• Focus on computer category, analyze specific models in depth\n• Communicate market strategies with Dell, Huawei and other brands\n• Consider launching targeted promotional activities\n• Develop targeted promotional strategies for computer brands\n\n✅ **Analysis Complete**\nBased on multi-dimensional data analysis, providing actionable business decision recommendations",
          description: "Generate complete analysis report and decision recommendations"
        }
      }
    },
    retail_2: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Which products sold well in the past year?",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nIdentify the best-selling products in the past year, measuring product popularity and profitability based on total profit.\n\n📋 **Execution Plan**\n1. Calculate total profit for each product in the past year\n2. Identify hot-selling products by profit ranking\n3. Analyze product category and brand characteristics",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Product Profit Analysis",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 1.474 ms**\n\n```sql\nSELECT p.product_name, SUM(o.profit) AS total_profit \nFROM orders o JOIN products p ON o.product_id = p.product_id \nWHERE o.order_date >= DATE_SUB('2025-06-24', INTERVAL 1 YEAR) \nGROUP BY p.product_name ORDER BY total_profit DESC LIMIT 10\n```\n\n📊 **Query Results**\n• MacBook Pro 16\": 6,021,548 yuan\n• MacBook Pro 14\": 5,660,905 yuan\n• Alienware m15: 4,793,296 yuan\n• Galaxy Z Fold5: 4,286,622 yuan\n• iMac 24\": 3,997,009 yuan\n\n📈 **Smart Chart Analysis**\nProduct profit ranking chart generated",
          description: "SQL Tool executes data query to obtain product profit ranking",
          chart: "bar"
        },
        step3: {
          phase: "Product Feature Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Product Category Analysis**\n• **Laptops**: Occupy 6 of the top 10 positions, total profit exceeds 30 million\n• **Smartphones**: Galaxy Z Fold5, iPhone 15 Pro Max perform outstandingly\n• **All-in-One**: iMac 24\" enters top five, Apple ecosystem advantage evident\n• **Tablets**: iPad Pro 12.9\" stable profitability\n\n🏷️ **Brand Performance Analysis**\n• **Apple**: 4 products on the list, strong brand premium capability\n• **Dell**: Alienware, XPS series high-end positioning successful\n• **Samsung**: Foldable phone innovation gains market recognition\n• **Lenovo**: ThinkPad business laptops stable performance\n\n🎯 **Key Findings**\n**High-end products contribute the most profit**, Apple ecosystem performs outstandingly",
          description: "In-depth analysis of product categories and brand characteristics",
          chart: "pie"
        },
        step4: {
          phase: "Market Insight Report",
          ai: "📋 **Hot-selling Product Analysis Report**\n\n🎯 **Core Conclusions**\nHigh-end products are the main profit drivers in the past year\n\n⚠️ **Key Findings**\n1. **High-end laptops dominate the market** (6 of top 10 positions)\n2. **Apple ecosystem profitability outstanding** (4 products on the list)\n3. **Innovative products gain premium** (foldable phones perform excellently)\n\n💡 **Strategy Recommendations**\n• Continue to cultivate high-end laptop market, focus on new technology trends\n• Strengthen cooperation with Apple and other leading brands\n• Pay attention to market opportunities for innovative products like foldable screens\n• Optimize inventory and marketing strategies for high-profit products\n\n✅ **Analysis Complete**\nBased on product profit data, providing market strategy recommendations",
          description: "Generate complete product analysis report and strategy recommendations"
        }
      }
    },
    retail_3: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Analyze customer purchasing behavior and identify high-value customer groups",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nAnalyze customer purchasing behavior data to identify high-value customer groups, providing data support for precision marketing and customer relationship management.\n\n📋 **Execution Plan**\n1. Analyze customer spending distribution\n2. Identify customer purchase frequency characteristics\n3. Build customer value segmentation model\n4. Generate customer group insight report",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Customer Consumption Analysis",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 1.256 ms**\n\n```sql\nSELECT \n  CASE \n    WHEN total_amount >= 50000 THEN 'High-value customers'\n    WHEN total_amount >= 20000 THEN 'Medium-value customers'\n    WHEN total_amount >= 5000 THEN 'Regular customers'\n    ELSE 'Low-value customers'\n  END AS customer_segment,\n  COUNT(*) AS customer_count,\n  AVG(total_amount) AS avg_amount\nFROM (\n  SELECT customer_id, SUM(payment_amount) AS total_amount\n  FROM orders WHERE order_date >= DATE_SUB(NOW(), INTERVAL 1 YEAR)\n  GROUP BY customer_id\n) customer_totals\nGROUP BY customer_segment\n```\n\n📊 **Query Results**\n• High-value customers: 1,247 people, average spending 78,650 yuan\n• Medium-value customers: 3,892 people, average spending 32,180 yuan\n• Regular customers: 12,567 people, average spending 8,920 yuan\n• Low-value customers: 28,394 people, average spending 2,340 yuan\n\n📈 **Smart Chart Analysis**\nCustomer value distribution chart generated",
          description: "Analyze customer spending distribution and value segmentation",
          chart: "pie"
        },
        step3: {
          phase: "Customer Behavior Deep Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **High-value Customer Characteristics**\n• **Purchase Frequency**: Average 3.2 purchases per month\n• **Preferred Categories**: High-end laptops (45%), smartphones (28%), tablets (18%)\n• **Purchase Time**: Active on weekday afternoons and weekend mornings\n• **Average Order Value**: 2,450 yuan per order\n\n💰 **Medium-value Customer Characteristics**\n• **Purchase Frequency**: Average 1.8 purchases per month\n• **Preferred Categories**: Mid-range laptops (38%), smartphones (32%), accessories (20%)\n• **Purchase Time**: Concentrated on weekends and holidays\n• **Average Order Value**: 1,780 yuan per order\n\n👥 **Regular Customer Characteristics**\n• **Purchase Frequency**: Average 0.9 purchases per month\n• **Preferred Categories**: Entry-level laptops (42%), phone accessories (35%), digital products (15%)\n• **Purchase Time**: Concentrated during promotional periods\n• **Average Order Value**: 990 yuan per order\n\n📈 **Key Insights**\n**High-value customers contribute 65% of revenue** but only account for 2.7% of total customers",
          description: "In-depth analysis of behavioral characteristics of different value customer groups",
          chart: "bar"
        },
        step4: {
          phase: "Customer Value Insight Report",
          ai: "📋 **Customer Behavior Insight Analysis Report**\n\n🎯 **Core Conclusions**\nCustomer value shows obvious 80-20 distribution characteristics\n\n⚠️ **Key Findings**\n1. **High-value customers contribute significantly** (2.7% customers contribute 65% revenue)\n2. **Medium-value customers have great growth potential** (8.4% customer group can be focused on)\n3. **Regular customers have large base** (27.2% customers need activation strategies)\n4. **Low-value customers account for too high proportion** (61.7% need conversion or screening)\n\n💡 **Marketing Strategy Recommendations**\n• **High-value customers**: VIP exclusive services, new product priority experience, personalized recommendations\n• **Medium-value customers**: Upgrade incentive programs, cross-category sales, member benefit enhancement\n• **Regular customers**: Promotional activity guidance, community marketing, repeat purchase incentives\n• **Low-value customers**: Automated marketing, cost control, value screening\n\n✅ **Analysis Complete**\nBased on customer behavior data, providing precision marketing strategy recommendations",
          description: "Generate complete customer value insight report and marketing strategies"
        }
      }
    },
    mfg_1: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Help me analyze the daily production targets for each base in March",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nAnalyze and display the daily production targets for each base in March, identifying production planning trends and anomalies.\n\n📋 **Execution Plan**\n1. Retrieve daily production targets for each base in March from database\n2. Analyze production trends and characteristics of each base\n3. Provide production planning optimization recommendations",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Production Data Query",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 1.031 ms**\n\n```sql\nSELECT `Base Name`, `Date`, `Production Target(A)` \nFROM `Zhongxin Saike Governance Data` \nWHERE `Date` LIKE 'March%' \nORDER BY `Base Name`, `Date` LIMIT 1000\n```\n\n📊 **Query Results**\n• Inner Mongolia Base: March production targets 8,829-12,269\n• Tianjin Base: March production targets 12,279-19,428\n• Yixing Base: March production targets 15,937-33,283\n• **Total: 121 records**\n\n📈 **Smart Chart Analysis**\nProduction trend chart generated",
          description: "Query daily production target data for each base in March",
          chart: "line"
        },
        step3: {
          phase: "Production Trend Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Inner Mongolia Base Trends**\n• **Early Month**: Stable around 8,600-8,800\n• **Mid Month**: Gradually climbing to above 12,000\n• **Late Month**: High volatility then falling back to 9,926\n• **Characteristics**: Rise first, then fluctuate at high levels, then fall back\n\n🏭 **Tianjin Base Trends**\n• **Fluctuation Range**: Between 12,279-19,428\n• **Change Characteristics**: Daily target values change frequently\n• **Peak**: Reached 19,428 on March 7th\n• **Characteristics**: Large fluctuations, no obvious sustained trend\n\n🏗️ **Yixing Base Trends**\n• **Early Month**: About 15,937 (aggregate value)\n• **Late Month**: About 33,283 (aggregate value)\n• **Growth Rate**: Over 100% growth\n• **Characteristics**: Obvious sustained upward trend\n\n📈 **Smart Chart Analysis**\nBase comparison analysis chart generated",
          description: "In-depth analysis of production trends and characteristics of each base",
          chart: "bar"
        },
        step4: {
          phase: "Optimization Recommendation Report",
          ai: "📋 **Production Target Analysis Report**\n\n🎯 **Core Conclusions**\nEach base shows different characteristics and trends in March production targets\n\n⚠️ **Key Findings**\n1. **Yixing Base rapid capacity improvement** (growth over 100%)\n2. **Tianjin Base planning fluctuates greatly** (needs stability improvement)\n3. **Inner Mongolia Base phased adjustment** (late month target decline)\n\n💡 **Optimization Recommendations**\n• Inner Mongolia Base: Analyze reasons for late month decline, optimize subsequent plans\n• Tianjin Base: Identify fluctuation factors, smooth production plans\n• Yixing Base: Focus on sustainability of capacity improvement\n• Establish cross-base capacity coordination mechanism\n\n✅ **Analysis Complete**\nBased on production data analysis, providing production planning optimization recommendations",
          description: "Generate complete production analysis report and optimization recommendations"
        }
      }
    },
    mfg_2: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "How are the daily trends of various factories in Yixing?",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nView the daily key indicator trends of various factories in Yixing base in March, including warehousing, qualification rate, scrap rate, etc.\n\n📋 **Execution Plan**\n1. Confirm the factory composition of Yixing base\n2. Obtain daily key indicator data for each factory\n3. Analyze performance differences and trends between factories",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Factory Data Query",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 0.987 ms**\n\n```sql\nSELECT `Date`, `Factory Name`, \nCAST(`Warehousing(A)` AS DECIMAL(10, 2)) AS `Warehousing(A)`,\nCAST(REPLACE(`Qualification Rate`, '%', '') AS DECIMAL(10, 2)) AS `Qualification Rate`\nFROM `Zhongxin Saike Governance Data` \nWHERE `Base Name` = 'Yixing' AND `Date` LIKE 'March%'\n```\n\n📊 **Query Results**\n• Phase 1&2 Factory: Warehousing 7.11-11.47 tons, qualification rate 98-99%\n• Phase 3 Factory: Warehousing 1.79-12.85 tons, qualification rate 98-99%\n• **Total: 60 records**\n\n📈 **Smart Chart Analysis**\nFactory comparison trend chart generated",
          description: "Query daily key indicators for each factory in Yixing base",
          chart: "line"
        },
        step3: {
          phase: "Factory Performance Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Phase 1&2 Factory Performance**\n• **Warehousing Trend**: 7-11 tons fluctuation, reaching 11.47 tons at month-end\n• **Qualification Rate**: Stable above 98%\n• **Scrap Rate**: Most dates below 0.1%\n• **Characteristics**: Relatively stable, smaller fluctuation range\n\n🏭 **Phase 3 Factory Performance**\n• **Warehousing Trend**: 2-13 tons significant growth, exceeding Phase 1&2 at month-end\n• **Qualification Rate**: Above 98%, slight fluctuation\n• **Scrap Rate**: Occasionally above 0.1%, highest 0.23%\n• **Characteristics**: Obvious growth momentum, rapid capacity ramp-up\n\n📈 **Comparison Analysis**\n• **Capacity Growth**: Phase 3 factory grows faster\n• **Quality Stability**: Phase 1&2 factory more stable\n• **Month-end Performance**: Phase 3 factory surpasses Phase 1&2\n\n📈 **Smart Chart Analysis**\nFactory performance comparison chart generated",
          description: "In-depth analysis of performance differences and trends of each factory",
          chart: "bar"
        },
        step4: {
          phase: "Factory Optimization Recommendations",
          ai: "📋 **Yixing Factory Trend Analysis Report**\n\n🎯 **Core Conclusions**\nTwo factories in Yixing base show different development trends\n\n⚠️ **Key Findings**\n1. **Phase 3 factory rapid growth** (warehousing volume exceeds Phase 1&2 at month-end)\n2. **Phase 1&2 factory stable operation** (all indicators fluctuate less)\n3. **Overall good quality control** (qualification rates all above 98%)\n\n💡 **Optimization Recommendations**\n• Analyze driving factors for Phase 3 factory growth in depth\n• Focus on reasons for production target achievement rate fluctuations\n• Continuously monitor scrap rate changes\n• Compare and analyze operational models of both factories, learn from each other\n\n✅ **Analysis Complete**\nBased on factory data analysis, providing operational optimization recommendations",
          description: "Generate complete factory analysis report and optimization recommendations"
        }
      }
    },
    mfg_3: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "How many fragments were there in the three bases last month?",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nStatistics on fragment quantities of three production bases last month, analyze quality control situation of each base, identify abnormal bases and provide improvement recommendations.\n\n📋 **Execution Plan**\n1. Query fragment statistics data of three bases\n2. Compare and analyze quality performance of each base\n3. Identify abnormal causes and provide optimization recommendations",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Data Query Analysis",
          ai: "🔍 **Executing Tool: Auto SQL Query**\n⏱️ **Duration: 1.021 ms**\n\n```sql\nSELECT `Base Name`, AVG(CAST(REPLACE(`Fragment Rate (Excluding Scrap Rate)`, '%', '') AS DECIMAL(10, 2))) AS avg_fragmentation_rate \nFROM `Zhongxin Saike Governance Data` \nWHERE `Month` = '2025-03' GROUP BY `Base Name`\n```\n\n📊 **Query Results**\n• Inner Mongolia Base: 0.18% fragment rate\n• Tianjin Base: 0.16% fragment rate\n• Yixing Base: 0.105% fragment rate\n• **Total: 3 base data**\n\n📈 **Smart Chart Analysis**\nBase fragment rate comparison chart generated",
          description: "Query and statistics fragment rate data of each base",
          chart: "bar"
        },
        step3: {
          phase: "Quality Analysis Diagnosis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Quality Performance Comparison**\n• **Yixing Base**: Lowest fragment rate (0.105%), best quality control ✅\n• **Tianjin Base**: Medium fragment rate (0.16%), good performance ✅\n• **Inner Mongolia Base**: Highest fragment rate (0.18%), needs improvement ⚠️\n\n🏷️ **Difference Analysis**\n• **Equipment Status**: Inner Mongolia base equipment may need maintenance\n• **Operation Standards**: Yixing base executes strictest standards\n• **Environmental Factors**: Production environment differences affect each base\n• **Personnel Training**: Training level differences exist\n\n🎯 **Key Findings**\n**Yixing base can serve as quality benchmark**, Inner Mongolia base needs key improvement\n\n📈 **Smart Chart Analysis**\nQuality trend analysis chart generated",
          description: "In-depth analysis of quality control difference causes of each base",
          chart: "line"
        },
        step4: {
          phase: "Improvement Recommendation Report",
          ai: "📋 **Quality Control Analysis Report**\n\n🎯 **Core Conclusions**\nFragment rates of three bases last month show obvious differences, Yixing base performs best\n\n⚠️ **Key Findings**\n1. **Yixing base quality optimal** (0.105% fragment rate)\n2. **Inner Mongolia base needs improvement** (0.18% fragment rate)\n3. **Quality management differences exist** (71% difference between highest and lowest)\n\n💡 **Improvement Recommendations**\n• Promote Yixing base's quality management experience\n• Inner Mongolia base: Strengthen equipment maintenance and personnel training\n• Establish cross-base quality benchmarking system\n• Regularly conduct quality management exchanges and training\n\n✅ **Analysis Complete**\nBased on quality data analysis, providing targeted improvement solutions",
          description: "Generate complete quality analysis report and improvement recommendations"
        }
      }
    },
    fin_1: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Please help me assess whether ABC company has loan risks",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nTo assess the potential loan risk of ABC company, we need to comprehensively analyze its basic information, financial status, negative news and other dimensions.\n\n📋 **Execution Plan**\n1. Obtain basic company registration information and business status\n2. Analyze cash flow and financial health\n3. Search for negative news and reputation risk assessment",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Basic Information Query",
          ai: "🔍 **Executing Tool: Company Basic Information Query**\n⏱️ **Duration: 1.586 ms**\n\n📊 **Query Results**\n• Company Name: ABC Company\n• Registered Capital: 11,165,000 yuan\n• Tax Credit Rating: A-level credit\n• Business Status: Normal\n• Dishonest Enterprise: No\n• Number of lawsuits in the past three years: 0\n• Negative public opinion in the past year: 0\n\n📈 **Smart Chart Analysis**\nCompany basic profile chart generated",
          description: "Obtain basic company registration information and credit status",
          chart: "bar"
        },
        step3: {
          phase: "Risk Comprehensive Analysis",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Cash Flow Analysis** (Duration: 7.082 ms)\n• **Transaction with GHI Company**: 210,000 yuan, marked as medium risk ⚠️\n• **Other company transactions**: Small amounts, marked as low risk ✅\n• **Transaction frequency**: Within normal range\n• **Abnormal identification**: Need to focus on GHI company related risks\n\n🏷️ **Negative News Analysis** (Duration: 2.803 ms)\n• **Negative news found**: 1 item\n• **Event content**: Computing service contract false information\n• **Impact assessment**: May damage company reputation\n• **Risk level**: Medium reputation risk\n\n🎯 **Enterprise Credit Report** (Duration: 2.567 ms)\n• **Tax status**: Normal\n• **Registration information**: Basically consistent\n• **Credit record**: Good\n\n🎯 **Key Findings**\n**Overall good credit**, but there are capital flow and reputation risks",
          description: "Multi-dimensional analysis of company risk status",
          chart: "radar"
        },
        step4: {
          phase: "Risk Assessment Report",
          ai: "📋 **ABC Company Loan Risk Assessment Report**\n\n🎯 **Core Conclusions**\nABC company has good overall credit status, but there are certain potential risks\n\n⚠️ **Risk Identification**\n1. **Capital flow risk** (frequent transactions with GHI company)\n2. **Reputation risk** (computing service contract false information)\n3. **Information consistency risk** (registration address discrepancies)\n\n💡 **Risk Control Recommendations**\n• Investigate the background of capital transactions with GHI company in depth\n• Assess the long-term impact of negative news on company reputation\n• Verify the consistency of registration address information\n• Combine financial statements for more comprehensive risk assessment\n\n✅ **Analysis Complete**\nBased on multi-dimensional risk analysis, recommend cautious lending with enhanced monitoring",
          description: "Generate complete risk assessment report and risk control recommendations"
        }
      }
    },
    fin_2: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Based on historical return data, optimize investment portfolio allocation recommendations",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nBased on historical return data analysis, provide scientific investment portfolio optimization allocation recommendations to balance risk and return.\n\n📋 **Execution Plan**\n1. Analyze historical return performance of various asset classes\n2. Calculate risk-return ratios and correlations\n3. Build optimal investment portfolio allocation\n4. Generate investment recommendations and risk warnings",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Historical Return Analysis",
          ai: "🔍 **Executing Tool: Asset Return Data Query**\n⏱️ **Duration: 2.156 ms**\n\n```sql\nSELECT asset_type, year, annual_return, volatility, sharpe_ratio\nFROM investment_performance \nWHERE year >= 2019 AND year <= 2023\nORDER BY asset_type, year\n```\n\n📊 **Query Results**\n• **Equity Funds**: Annual return 8.5%-15.2%, volatility 18.3%\n• **Bond Funds**: Annual return 3.2%-6.8%, volatility 4.2%\n• **Hybrid Funds**: Annual return 5.8%-11.4%, volatility 12.1%\n• **Money Market Funds**: Annual return 2.1%-3.5%, volatility 0.8%\n• **Gold ETF**: Annual return -2.3%-12.8%, volatility 16.7%\n\n📈 **Smart Chart Analysis**\nAsset return trend chart generated",
          description: "Analyze historical return performance of various asset classes",
          chart: "line"
        },
        step3: {
          phase: "Risk-Return Optimization",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n📊 **Correlation Analysis**\n• **Equity-Bond Correlation**: -0.23 (negative correlation, effective risk diversification)\n• **Equity-Gold Correlation**: 0.15 (low correlation)\n• **Bond-Money Market Correlation**: 0.68 (medium positive correlation)\n• **Hybrid-Equity Correlation**: 0.82 (high correlation)\n\n⚖️ **Risk-Return Optimization Calculation**\n• **Conservative Portfolio**: Equity 20% + Bond 50% + Money Market 30%\n  - Expected annual return: 5.2%, Risk level: Low\n• **Balanced Portfolio**: Equity 40% + Bond 30% + Hybrid 20% + Money Market 10%\n  - Expected annual return: 7.8%, Risk level: Medium\n• **Aggressive Portfolio**: Equity 60% + Hybrid 25% + Bond 10% + Gold 5%\n  - Expected annual return: 10.5%, Risk level: High\n\n🎯 **Sharpe Ratio Ranking**\n1. Balanced Portfolio: 0.64\n2. Conservative Portfolio: 0.58\n3. Aggressive Portfolio: 0.52",
          description: "Calculate optimal investment portfolio allocation schemes"
        },
        step4: {
          phase: "Investment Recommendation Report",
          ai: "📋 **Investment Portfolio Optimization Allocation Report**\n\n🎯 **Recommended Scheme**\n**Balanced Investment Portfolio** (Optimal Sharpe Ratio)\n\n💼 **Allocation Details**\n• **Equity Funds**: 40% (Expected return contribution 4.2%)\n• **Bond Funds**: 30% (Expected return contribution 1.5%)\n• **Hybrid Funds**: 20% (Expected return contribution 1.6%)\n• **Money Market Funds**: 10% (Expected return contribution 0.3%)\n\n📈 **Expected Performance**\n• **Annual Return**: 7.8%\n• **Annual Volatility**: 9.2%\n• **Sharpe Ratio**: 0.64\n• **Maximum Drawdown**: Expected -12.5%\n\n💡 **Investment Recommendations**\n• Recommend gradual position building to reduce timing risk\n• Rebalance allocation ratios quarterly\n• Monitor market environment changes and adjust timely\n• Maintain 3-6 months emergency funds in money market funds\n\n⚠️ **Risk Warning**\nHistorical returns do not represent future performance, invest with caution\n\n✅ **Analysis Complete**\nBased on quantitative analysis, providing scientific investment allocation scheme",
          description: "Generate complete investment portfolio optimization report"
        }
      }
    },
    fin_3: {
      title: "Agent + Tool Smart Scheduling Demo",
      subtitle: "Streamlined Intelligent Analysis Process",
      steps: {
        step1: {
          phase: "Problem Identification + Intent Confirmation",
          user: "Identify abnormal transaction patterns to enhance anti-fraud capabilities",
          ai: "✓ **Intent Confirmation Complete**\n\n🎯 **Analysis Intent**\nAnalyze transaction data through machine learning algorithms to identify abnormal transaction patterns and potential fraudulent behaviors, enhancing risk control capabilities.\n\n📋 **Execution Plan**\n1. Obtain recent transaction data for preprocessing\n2. Apply anomaly detection algorithms to identify suspicious transactions\n3. Analyze abnormal transaction characteristics and risk levels\n4. Generate anti-fraud monitoring recommendations",
          description: "AI confirms user intent and formulates analysis plan"
        },
        step2: {
          phase: "Transaction Data Analysis",
          ai: "🔍 **Executing Tool: Transaction Data Query and Preprocessing**\n⏱️ **Duration: 3.247 ms**\n\n```sql\nSELECT transaction_id, amount, transaction_time, \n       merchant_type, user_location, device_info,\n       risk_score\nFROM transactions \nWHERE transaction_date >= DATE_SUB(NOW(), INTERVAL 7 DAY)\nAND amount > 0\nORDER BY transaction_time DESC\nLIMIT 10000\n```\n\n📊 **Data Overview**\n• **Total Transactions**: 9,847 transactions\n• **Transaction Amount Range**: ¥0.01 - ¥89,500\n• **Average Transaction Amount**: ¥1,247\n• **Abnormal Transaction Screening**: 156 transactions (1.58%)\n• **High Risk Transactions**: 23 transactions (0.23%)\n\n📈 **Smart Chart Analysis**\nTransaction distribution scatter plot generated",
          description: "Obtain and preprocess transaction data",
          chart: "scatter"
        },
        step3: {
          phase: "Anomaly Pattern Recognition",
          ai: "🔄 **Agent Smart Scheduling Multi-Tool Parallel Analysis**\n\n🤖 **Machine Learning Anomaly Detection**\n• **Isolation Forest Algorithm**: Detected 47 anomaly points\n• **LOF Algorithm**: Identified 31 local anomalies\n• **DBSCAN Clustering**: Found 3 abnormal transaction clusters\n• **Statistical Anomaly**: 18 transactions with Z-score > 3\n\n⚠️ **Abnormal Transaction Feature Analysis**\n1. **Amount Anomaly**: Large transactions over ¥50,000 (8 transactions)\n2. **Time Anomaly**: High-frequency transactions at 2-5 AM (12 transactions)\n3. **Geographic Anomaly**: Cross-regional transactions in short time (15 transactions)\n4. **Device Anomaly**: Same device multiple account transactions (7 transactions)\n5. **Merchant Anomaly**: High-risk merchant type transactions (11 transactions)\n\n🎯 **Risk Level Distribution**\n• **Extremely High Risk**: 5 transactions (need immediate freezing)\n• **High Risk**: 18 transactions (need manual review)\n• **Medium Risk**: 33 transactions (enhanced monitoring)\n• **Low Risk**: 9,791 transactions (normal transactions)",
          description: "Apply multiple algorithms to identify abnormal transaction patterns",
          chart: "scatter"
        },
        step4: {
          phase: "Anti-fraud Monitoring Report",
          ai: "📋 **Transaction Anomaly Detection and Anti-fraud Report**\n\n🚨 **Emergency Handling**\n**5 extremely high-risk transactions need immediate processing**\n\n📊 **Abnormal Transaction Details**\n• **Transaction ID: TXN_20241217_001**: ¥89,500, 3:21 AM, remote login\n• **Transaction ID: TXN_20241217_045**: ¥67,800, same device multiple accounts\n• **Transaction ID: TXN_20241216_892**: ¥55,200, high-risk merchant\n• **Transaction ID: TXN_20241216_734**: ¥78,900, geographic location jump\n• **Transaction ID: TXN_20241215_456**: ¥45,600, abnormal time pattern\n\n🛡️ **Risk Control Recommendations**\n• **Immediate Freeze**: 5 extremely high-risk transaction accounts\n• **Manual Review**: 18 high-risk transactions, complete within 24 hours\n• **Enhanced Monitoring**: 33 medium-risk transactions, set real-time alerts\n• **Rule Optimization**: Update anomaly detection threshold parameters\n\n📈 **Model Performance**\n• **Accuracy**: 94.2%\n• **Recall**: 89.7%\n• **False Positive Rate**: 5.8%\n• **Detection Efficiency**: Average 3.2ms per transaction\n\n💡 **System Optimization Recommendations**\n• Add device fingerprint recognition dimensions\n• Optimize geographic location anomaly judgment logic\n• Establish merchant risk rating dynamic update mechanism\n\n✅ **Analysis Complete**\nReal-time monitoring system updated, abnormal transaction alert mechanism activated",
          description: "Generate complete anti-fraud monitoring report and handling recommendations"
        }
      }
    }
  },

  // Final CTA Section
  finalCTA: {
    title: 'More Efficient Data Analysis, More Agile Business Decisions',
    button: 'Book Demo'
  }
};
